// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__pb2f_","footer":"ModalInfo_footer__2MiXn"};